export enum PostageUsageType {
    Sends = 1,
    Forwarding = 2,
    SendsPages = 3
}

export type PostageItemType = {
    compensationIncluded: number | null;
    insuranceIncluded: number | null;
    label: string;
    postageDestinations: Array<string>;
    proofOfDelivery: boolean;
    signedDelivery: boolean;
    sizeDescription: string;
    trackedDelivery: boolean;
    value: number;
}
